<template>
    <div class="help-list">
        <heading title="Help Messages" tag="help-list-title">
            <b-button v-if="canCreate"
                      variant="primary"
                      :to="{name:'helpCreate'}">
                Add Help Message
                <b-icon-plus-square/>
            </b-button>
        </heading>
        <data-table ref="dataTable"
                    persistName="help-filter"
                    :show-filters="true"
                    :show-pager="true"
                    :get-items="getEntries"
                    v-model="filters"
                    :fields="fields">
            <!-- template for custom columns -->
            <template v-slot:customField="slotProps">
                <template v-if="slotProps.row.field.key === 'content'">
                    {{ stripTags(slotProps.row.item.content) }}
                </template>
                <template v-else-if="slotProps.row.field.key === 'actions'">
                    <b-button size="sm" variant="secondary"
                              class="mr-2"
                              :to="{ name: 'helpView', params: { helpId : slotProps.row.item.id }}">
                        <b-icon-eye/>
                    </b-button>
                    <b-button size="sm" variant="secondary"
                              class="mr-2"
                              :to="{ name: 'helpEdit', params: { helpId : slotProps.row.item.id }}">
                        <b-icon-pencil-square/>
                    </b-button>
                </template>
            </template>
        </data-table>
    </div>
</template>

<script>
import Vue from 'vue'
import Company from '@/models/Company'
import Authorization from '@/providers/Authorization'

export default Vue.extend({
    name: 'HelpList',
    data () {
        return {
            helpFields: Company,
            fields: [
                { key: 'tag', sortable: true, label: 'Tag' },
                { key: 'content', sortable: false, label: 'Content' },
                { key: 'actions', sortable: false },
            ],
            filters: {
                tag: { field: 'tag', type: 'string', value: null, label: 'Tag' },
                content: { field: 'content', type: 'string', value: null, label: 'Content' },
            },
            canCreate: false,
        }
    },
    created () {
        Authorization.can({ action: 'create', model: 'help' })
            .then((can) => this.canCreate = can)
    },
    methods: {
        getEntries (listParams) {
            return this.$api.getItems(this, 'help', this.filters, listParams)
        },
        stripTags (value) {
            let div = document.createElement('div')
            div.innerHTML = value
            return div.textContent || div.innerText || ''
        },
    }
})
</script>
